import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class MobileScroll extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    let isClickDisabled = false;

    window.addEventListener('scroll' , function() {
      isClickDisabled = true;

      clearTimeout($.data($(this), 'scrollTimer'));

      $.data($(this), 'scrollTimer', setTimeout(function() {
        isClickDisabled = false;
      }, 150));

    });


    $('body').on('click', function(event) {
      if (isClickDisabled){
        event.preventDefault();
      }
    });

  }


}